export const generateRandomString = () => Math.random().toString(16).slice(2);
